<template>
	<div>
		<div class="flexBetween" style="margin-bottom: 20px">
			<h3 style="margin-bottom: 0">商品清单</h3>
			<!--			<button class="btn" type="button" @click="handleDownloadBatch" v-if="tradeStatus > 0 && tradeStatus != 4 && tradeStatus != 8 && hasRefundableProducts(orderDetails)">-->
			<!--				<span>批量下载PDF</span>-->
			<!--			</button>-->

			<el-button v-click-once="3000" size="small" type="primary" @click="handleExport"> 导出订单 </el-button>
		</div>

		<div class="carttable" style="width: 100%">
			<table class="rgoodbox goodbox-item">
				<tr class="goods-th">
					<td>商品名称</td>
					<td class="tc" width="15%" v-if="!isVIPOrder">价格</td>
					<td class="tc" width="8%" v-if="!isVIPOrder">数量</td>
					<td class="tc" width="8%">总计</td>
				</tr>
				<tr v-for="(info, index) in orderDetails" :key="index">
					<td>
						<span v-if="info.isDigit !== null" :class="info.isDigit == 0 ? (info.skuId ? 'colorblue' : 'colororange') : info.isDigit == 1 ? 'colorgreen' : 'colorred'"
							>【{{ info.isDigit == 0 ? (info.skuId ? '纸质版' : '额外添加') : info.isDigit == 1 ? '电子版' : '结构化版' }}】</span
						>
						<a :class="{ 'g-item-standard': info.skuId !== null }" @click="toStandardDet(info)">{{ formatProductName(info) }}</a>
						<!-- {{ info.standardCode ? info.standardCode + ' ' : '' }}{{ info.spuName }}  -->
						<!-- <span v-if="isVIPOrder">{{ info.skuName }}</span> -->
						<!-- <p class="sku">{{ info.skuName }}</p> -->
						<div class="g-atcs" v-if="tradeStatus > 0 && tradeStatus != 4 && tradeStatus != 8" style="margin-top: 10px">
							<div v-if="info.isDigit == 0 && info.skuId">
								<button class="btn" type="button" @click="handleReadPdf(info.skuId)">
									<span>在线阅读</span>
								</button>
							</div>
							<div v-if="info.isDigit == 1">
								<button class="btn" type="button" @click="handleReadPdf(info.skuId)">
									<span>在线阅读</span>
								</button>

								<button class="btn" type="button" @click="handleDownload(info.standardId, info.skuName)">
									<span>下载PDF</span>
								</button>
							</div>
							<div v-if="info.isDigit == 2">
								<button class="btn" type="button" @click="handleReadJSON(info.skuId)">
									<span>在线阅读</span>
								</button>
							</div>
						</div>
					</td>
					<td class="tc" style="text-align: left" v-if="!isVIPOrder">
						<div class="flexCenter">
							<em v-if="info.skuId"> {{ info.salePrice }}元</em>
							<em v-else
								><i style="font-style: normal" class="pending-price">{{ info.salePrice ? info.salePrice + '元' : '待定价' }}</i>
							</em>
						</div>
					</td>
					<td class="tc" v-if="!isVIPOrder">{{ info.buyNum }}</td>
					<td class="now-price tc">
						<div v-if="info.totalPrice">{{ info.totalPrice }}元</div>
						<div v-else>--</div>
					</td>
				</tr>
			</table>
		</div>
		<!-- 下载pdf电子版 -->
		<DialogWatermark ref="dialogWatermark" @confirmInfo="confirmDownload"></DialogWatermark>
	</div>
</template>

<script>
	import DialogWatermark from '@/views/StandardsView/components/DialogWatermark.vue';
	import TLoading from '@/utils/TLoading.js';
	import User from '@/utils/User.js';
	import { getConsumerOrderQueryStandard } from '@/api/order/order.js';
	import TMessage from '@/utils/TMessage.js';
	import hiprintNest from '@/utils/hiprintNest.js';
	import orderDataTemplate from '/public/hiprintTemplate/order.js';
	export default {
		props: {
			orderDetails: {
				type: Array,
				default: () => []
			},
			orderBasic: {
				type: Object,
				default: () => {}
			},
			orderAddress: {
				type: Object,
				default: () => {}
			}
		},
		data() {
			return {
				downPdfParams: {
					skuId: '',
					watermark: ''
				},
				pdfName: ''
			};
		},
		components: {
			DialogWatermark
		},
		methods: {
			// 格式化产品名称：如果 spuName 已包含 standardCode，则不重复拼接
			formatProductName(item) {
				if (item.isDigit == 0 && !item.skuId) {
					return item.spuName;
				}
				if (item.spuName && item.standardCode && item.spuName.indexOf(item.standardCode) !== -1) {
					return item.spuName;
				}
				return item.standardCode ? item.standardCode + ' ' + item.spuName : item.spuName;
			},

			toStandardDet(ginfo) {
				if (!ginfo.skuId) return;
				const { standardId, skuName } = ginfo;
				const targetRoute = this.$router.resolve({
					path: '/StandardsDet',
					query: { id: standardId }
				});
				window.open(targetRoute.href, '_blank');
			},

			//导出单子
			handleExport() {
				let buyNumTotal = 0;
				let beforeAmountTotal = 0;
				let afterAmountTotal = 0;
				this.orderDetails.forEach((item, index) => {
					buyNumTotal += item.buyNum;
					item.no = index + 1;

					if (item.isDigit == 0 && !item.skuId) {
						item.name = item.spuName;
						item.isDigitStr = '额外添加';
					} else {
						item.name = item.standardCode && item.skuName.indexOf(item.standardCode) === -1 ? item.standardCode + ' ' + item.skuName : item.skuName;
						item.isDigitStr = item.isDigit == 1 ? '电子版' : '纸质版';
					}

					item.fixedPrice = item.fixedPrice || item.salePrice || null;

					//折扣率
					if (item.fixedPrice && item.salePrice) {
						item.discount = (item.salePrice / item.fixedPrice).toFixed(2);
						item.beforeAmount = (item.buyNum * item.fixedPrice).toFixed(2);
						item.afterAmount = (item.buyNum * item.salePrice).toFixed(2);
					} else {
						item.discount = null;
						item.beforeAmount = null;
						item.afterAmount = null;
					}

					//总码洋（原价）
					beforeAmountTotal += Number(item.buyNum * item.fixedPrice);
					//总实洋（总价）
					afterAmountTotal += Number(item.totalPrice);
				});

				let receiverName,
					receiverPhone,
					receiverAddress = '';
				if (this.orderAddress != null) {
					let receiveAddressInfo = this.orderAddress;
					receiverName = receiveAddressInfo.receiverName;
					receiverPhone = receiveAddressInfo.receiverPhone;
					receiverAddress = receiveAddressInfo.provinceName + receiveAddressInfo.cityName + receiveAddressInfo.districtName + receiveAddressInfo.detailAddress;
				}
				let printData = {
					consumerCode: this.orderBasic.consumerCode,
					tradeNo: this.orderBasic.tradeNo,
					tradeOrderTypeTotal: this.orderDetails.length,
					totalAmount: (this.orderBasic.totalAmount + this.orderBasic.freightAmount).toFixed(2),
					beforeAmountTotal: beforeAmountTotal.toFixed(2),
					afterAmountTotal: afterAmountTotal.toFixed(2),
					payTypeStr: this.orderBasic.payType == 0 ? '微信' : this.orderBasic.payType == 1 ? '支付宝' : '对公转账',
					freightAmount: this.orderBasic.freightAmount,
					buyNumTotal: buyNumTotal,
					remark: this.orderBasic.remark,
					receiverName: receiverName,
					receiverPhone: receiverPhone,
					receiverAddress: receiverAddress,
					tradeOrderDetails: this.orderDetails,
					createBy: this.orderBasic.createBy,
					createTime: this.orderBasic.createTime
				};
				// return
				hiprintNest(printData, orderDataTemplate, this.orderBasic.tradeNo);
			},

			//判断商品中有无电子版
			hasRefundableProducts(orderDetails) {
				return orderDetails.some(info => info.isDigit == 1);
			},
			//结构化阅读
			handleReadJSON(skuId) {
				getConsumerOrderQueryStandard(skuId).then(res => {
					if (res.code == 200) {
						this.info = res.data;
						if (this.info.defaultJson) {
							this.$router.push({ path: '/StandardsDoc', query: { docId: this.info.standardId } });
						} else {
							TMessage.warning('未找到文件');
						}
					}
				});
			},

			// 在线阅读
			handleReadPdf(skuId) {
				getConsumerOrderQueryStandard(skuId).then(res => {
					if (res.code == 200) {
						this.info = res.data;
						if (this.info.defaultPdf) {
							const targetRoute = this.$router.resolve({
								path: '/StandardsPdf',
								query: { id: this.info.standardId, code: this.info.standardCode, title: this.info.standardName, fileName: this.info.defaultPdf, docId: this.info.standardId }
							});
							window.open(targetRoute.href, '_blank');
							// this.$router.push({ path: '/index/StandardsPdf', query: { id: this.info.standardId, title: this.info.standardName, fileName: this.info.defaultPdf, docId: this.info.standardId } });
						} else {
							TMessage.warning('未找到文件');
						}
					}
				});
			},

			handleDownloadBatch() {
				this.pdfName = '电子版文件';
				if (this.orderBasic.waterMark) {
					let params = {
						tradeNo: this.orderBasic.tradeNo
					};
					this.handleWatermarkConfirm(params, 'batch');
				} else {
					// this.downPdfParams.skuId = skuId;
					this.downPdfParams.tradeNo = this.orderBasic.tradeNo;
					this.$refs.dialogWatermark.dialogVisible = true;
				}
			},

			handleDownload(standardId, skuName) {
				this.pdfName = skuName;
				this.handleWatermarkConfirm(standardId, 'single');

				return;
				if (this.orderBasic.waterMark) {
					let params = {
						skuId,
						tradeNo: this.orderBasic.tradeNo
					};
					this.handleWatermarkConfirm(params, 'single');
				} else {
					this.downPdfParams.skuId = skuId;
					this.downPdfParams.tradeNo = this.orderBasic.tradeNo;
					this.$refs.dialogWatermark.dialogVisible = true;
				}
			},

			confirmDownload(val) {
				this.downPdfParams.watermark = val.watermark;
				this.downPdfParams.waterType = val.waterType;
				this.handleWatermarkConfirm(this.downPdfParams);
			},

			async handleWatermarkConfirm(standardId, type) {
				this.loadingInstance = TLoading.startBgWhite({ text: '文件准备中，请耐心等待 \n 若长时间未启动下载，请刷新页面后重试' });
				try {
					const response = await fetch(`/webL_api/consumer/order/downloadCorporateBook/${standardId}`, {
						method: 'get',
						headers: {
							Authorization: 'Bearer ' + User.getToken(),
							'corporate-id': User.getCorporate().corporateId,
							'Content-Type': 'application/json'
						}
					});

					if (!response.ok) {
						throw new Error(`HTTP error! status: ${response.status}`);
					}

					const arrayBuffer = await response.arrayBuffer();
					const blob = new Blob([arrayBuffer], { type: 'zip' });

					this.$refs.dialogWatermark.dialogVisible = false;
					// 创建下载链接而不是打开文件
					this.downloadFile(blob, this.pdfName + '.zip');

					// this.postConsumerOrderList();
				} catch (error) {
					TLoading.close(this.loadingInstance);
					console.error('下载文件失败:', error);
					this.$message.error('文件下载失败，请重试！');
				}
			},

			// 通用文件下载方法
			downloadFile(blob, filename) {
				const url = URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.download = filename;
				link.style.display = 'none';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				URL.revokeObjectURL(url); // 释放内存
				// 显示下载成功提示
				this.$message.success('文件下载成功！');
				TLoading.close(this.loadingInstance);
			}
		},
		computed: {
			tradeStatus() {
				return this.orderBasic.tradeStatus;
			},
			isVIPOrder() {
				// 判断订单号是否包含VIP字符
				// VIP订单通常是单次购买，不需要显示数量
				return this.orderBasic && this.orderBasic.tradeNo && this.orderBasic.tradeNo.toUpperCase().includes('VIP');
			}
		}
	};
</script>
<style lang="less" scoped>
	.cartbox {
		// margin-bottom: 20px;
		// background-color: #ffffff;
		// box-shadow: 0px 3px 7px 0px rgba(0, 122, 255, 0.1);
		// border-radius: 15px;
		h3 {
			margin: 0;
			font-weight: 400;
			font-size: 18px;
			color: #333333;
			margin-bottom: 20px;
		}
	}
	.g-item-standard {
		cursor: pointer;
		transition: color 0.2s;
		color: inherit;
		text-decoration: none;

		&:hover {
			color: #155dfc;
		}

		&:active {
			color: #155dfc;
		}
	}
	.goodbox-item {
		width: 100%;
		margin-bottom: 20px;
		border-collapse: collapse;
		color: #333333;
		font-size: 14px;
		background-color: #ffffff;
		box-shadow: inset 0px 0px 5px 0px rgba(20, 116, 226, 0.5);
		border-radius: 2px;
		td {
			padding: 15px 20px;
			border-right: 1px solid #d0e3f9;
			border-bottom: 1px solid #d0e3f9;
		}
		td:last-child {
			border-right: 1px solid transparent;
		}
		.goods-th {
			color: #686f83;
		}
		.shuoming {
			vertical-align: text-top;
		}
		.ps-box {
			color: #686f83;
		}
		.ps-title {
			margin-bottom: 10px;
			color: #333333;
		}
		.ps-content {
			color: #888888;
			p {
				margin: 0 0 5px;
			}
		}
		.tfoot {
			text-align: right;
			background-color: rgba(227, 238, 255, 0.5);
			td {
				border-bottom: 1px solid transparent;
			}
			.o-info {
				margin-bottom: 6px;
			}
			span + span {
				margin-left: 20px;
			}
			em {
				font-style: normal;
				color: #ec2b2d;
			}
			.rprice {
				color: #ec2b2d;
				font-size: 16px;
				font-weight: bold;
			}
		}
	}

	.before-price {
		color: #969696;
		text-decoration: line-through;
		font-size: 12px;
		margin-right: 10px;
	}

	.now-price {
		font-size: 14px;
		color: #ff0f23;
		margin-right: 4px;
	}

	.vip-price {
		color: #1474e2;
		margin-top: 4px;
		display: inline-block;
		font-size: 12px;
	}

	.sku {
		color: #909399;
		font-size: 12px;
		margin: 8px 0;
		line-height: 18px;
	}

	///deep/ .el-link.el-link--primary {
	//	color: #333333;
	//}
	///deep/ .el-link.el-link--primary:hover {
	//	color: #1474e2;
	//}
	/deep/ .el-link.is-underline:hover:after {
		border-bottom: none;
	}
	/deep/ .el-card__header {
		padding: 30px 30px 0;
		border-bottom: none;
	}
	/deep/ .el-card__body,
	.el-main {
		padding: 20px 30px;
	}
	///deep/ .el-button--text {
	//	color: #333333;
	//	padding: 0;
	//}
	///deep/ .el-button--text:hover {
	//	color: #1474e2;
	//}
</style>
<style>
	.el-loading-text {
		white-space: pre-line; /* 或者 pre-wrap，根据需求选择 */
		line-height: 1.5; /* 可选，调整行高使换行后更美观 */
	}
</style>
